@if (!hideProfile) {
<header class="content">
  @if ( auth.user?.avatar && (auth.user?.avatar | fileUrl : { height: 124,
  width: 124 } | async); as src) {
  <img
    [ngSrc]="src"
    width="24"
    height="24"
    alt="Profile Photo"
    i18n-alt="@@profilePhoto"
  />
  } @else {
  <un-icon type="user" theme="outline"></un-icon>
  }
  <div class="name">
    <p class="t-medium t-ellipsis m-b-4">
      {{ auth.user?.firstName }} {{ auth.user?.lastName }}
    </p>
    <p class="t-tiny t-ellipsis c-secondary" i18n="@@photoNamePubliclyVisibile">
      Photo & name publicly visible
    </p>
  </div>
  <a
    [routerLink]="[RoutePath.dashboardSettings, RoutePath.profile]"
    class="t-large setting c-soft"
    ><un-icon type="setting" theme="fill"></un-icon
  ></a>
</header>
}

<un-message-threads-filters class="content"></un-message-threads-filters>
<div class="wrapper">
  @for (thread of facade.threads$ | async; track thread) {
  <un-message-thread-card
    class="content"
    [thread]="thread"
    [ngClass]="{
      active: (facade.selectedThread$ | async)?._id === thread._id
    }"
  ></un-message-thread-card>
  }
</div>
